/* unplugin-vue-components disabled */import { render } from "./input-switch.vue?vue&type=template&id=7fe10a1e&scoped=true"
import script from "./input-switch.vue?vue&type=script&lang=js"
export * from "./input-switch.vue?vue&type=script&lang=js"

import "./input-switch.vue?vue&type=style&index=0&id=7fe10a1e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fe10a1e"],['__file',"src/components/chat-input/input-switch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7fe10a1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7fe10a1e', __exports__)) {
    api.reload('7fe10a1e', __exports__)
  }
  
  module.hot.accept("./input-switch.vue?vue&type=template&id=7fe10a1e&scoped=true", () => {
    api.rerender('7fe10a1e', render)
  })

}


export default __exports__